import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

export default class LearnList extends Component {
  static propTypes = {
    renderCard: PropTypes.func.isRequired,
    apiUrl: PropTypes.string.isRequired,
    perPage: PropTypes.number,
  }

  static defaultProps = {
    perPage: 10,
  }

  constructor(props) {
    super(props);

    this.state = {
      cards: [],
      loading: false,
      reachedEnd: false,
      currentPage: 0,
    };
  }

  handleLoad = () => {
    const params = qs.parse(window.location.search.slice(1));
    Object.assign(params, { page: this.state.currentPage + 1 });

    if (this.request) this.request.abort();

    this.request = $.get(this.props.apiUrl, params, (cards) => {
      this.setState({
        cards: this.state.cards.concat(cards),
        loading: false,
        reachedEnd: (cards.length < this.props.perPage),
        currentPage: this.state.currentPage + 1,
      });
    });
  }

  handleParamsChange = () => {
    this.setState({
      reachedEnd: false,
      loading: true,
      cards: [],
      currentPage: 0,
    }, this.handleLoad);
  }

  componentDidMount() {
    this.unlistenParamsChange = router.listen(this.handleParamsChange);
    this.handleParamsChange(); // Initial load
  }

  componentWillUnmount() {
    this.unlistenParamsChange();
  }

  renderCardLoading = (n) => {
    let repetitions = [];
    for (let step = 0; step < (n || 1); step++) {
      repetitions.push(
        <div key={`loading-${step}`} className="u-relative u-z-75 u-flex u-flex-col u-border u-shadow u-rounded u-bg-white u-py-3 u-px-5 u-mb-4">
          <div className="u-flex u-mb-2">
            <div className="shimmer u-rounded-full u-w-11 u-h-11 u-mr-2" />
            <div className="u-flex u-flex-1 u-flex-col">
              <div className="shimmer u-rounded u-h-3 u-w-1/5 u-mb-1" />
              <div className="shimmer u-rounded u-h-3 u-w-1/3 u-mb-1" />
              <div className="shimmer u-rounded u-h-3 u-w-1/3" />
            </div>
          </div>
          <div className="shimmer u-rounded u-h-5 u-w-1/2 u-mb-1" />
          <div className="shimmer u-rounded u-h-4 u-w-full u-mb-1" />
          <div className="shimmer u-rounded u-h-4 u-w-full" />
        </div>
      );
    }
    return (
      <div>
        {repetitions}
      </div>
    );
  };


  render() {
    if (this.state.loading) {
      return this.renderCardLoading(5);
    }
    if (this.state.cards.length === 0) {
      return <div className="Card u-hintText">No content was found.</div>;
    }
    const results = this.state.cards.map(this.props.renderCard);
    return (
      <div>
        { results }
        { !this.state.reachedEnd && (
          <button className="Button u-w-full" onClick={this.handleLoad}>
            Show more
          </button>
        ) }
      </div>
    );
  }
}
